import { useTranslation } from 'react-i18next';

import { Button } from '@mui/joy';
import { QrScanner } from '@yudiel/react-qr-scanner';

import { type UseToggle } from '@/shared/hooks/UseToggle';

import { CancelIcon, QrIcon } from '@/shared/icons/Icons';
import KpcModal from '@/shared/components/2.0/layout/KpcModal';

const SCAN_DELAY = 1500; // 1.5 seconds

type Props = {
  toggle: UseToggle;
  callback: (result: string) => void;
  closeOnScan?: boolean;
};

const AccessKeyInstanceScanQrCodeModal: React.FC<Props> = ({
  toggle,
  callback,
  closeOnScan = true,
}) => {
  const { t } = useTranslation();

  return (
    <KpcModal
      toggle={toggle}
      title={t('_accessKeys.scanQrCode')}
      icon={<QrIcon />}
      actions={
        <div className="flex justify-end">
          <Button
            onClick={() => toggle.hide()}
            color="neutral"
            variant="outlined"
            startDecorator={<CancelIcon />}
          >
            {t('cancel')}
          </Button>
        </div>
      }
    >
      <div className="flex items-center justify-center">
        <div className="h-[600px] w-[600px] overflow-hidden rounded-lg">
          <QrScanner
            onDecode={(result) => {
              callback(result);
              if (closeOnScan) toggle.hide();
            }}
            scanDelay={SCAN_DELAY}
          />
        </div>
      </div>
    </KpcModal>
  );
};

export default AccessKeyInstanceScanQrCodeModal;
